import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';

import {
  ACCOUNT_SAVE_START,
  ACCOUNT_SAVE_SUCCESS,
  ACCOUNT_SAVE_ERROR,
  ACCOUNT_SAVE_LOADING,
  FETCH_ACCTS_SUCCESS,
  FETCH_OFFERS_SUCCESS,
  ADDRESS_SAVE_SUCCESS,
  EMAIL_SAVE_ERROR,
  EMAIL_SAVE_START,
  RESET_EMAIL_FORM,
  EMAIL_SAVE_SUCCESS,
  ADDRESS_SAVE_ERROR,
  RESET_PASSWORD_START,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  CANCEL_RESET_PASSWORD_FORM
} from '@src/app/accounts/summary';

import {
  INITIATE_OMS_LOOKUP,
  OMS_LOOKUP_SUCCESS,
  OMS_LOOKUP_FAILURE,
} from '@src/app/login/oms/actions';

export type State = {
  readonly loading: boolean;
  associatedAccounts: Array<any> | null;
  offers: Array<any> | null;
  emailSavedResult: Object | null;
  accountSavedResult: Object | null;
  updatedAccountNumbers: Array<any> | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case FETCH_ACCTS_SUCCESS:
      case EMAIL_SAVE_ERROR:
      case EMAIL_SAVE_SUCCESS:
      case ADDRESS_SAVE_SUCCESS:
      case ACCOUNT_SAVE_SUCCESS:
      case OMS_LOOKUP_SUCCESS:
      case ADDRESS_SAVE_ERROR:
      case OMS_LOOKUP_FAILURE:
      case ACCOUNT_SAVE_ERROR:
      case '@@INIT':
      case RESET_PASSWORD_SUCCESS:
      case RESET_PASSWORD_ERROR:
        return false;
      case INITIATE_OMS_LOOKUP:
        return true;
      case ACCOUNT_SAVE_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  associatedAccounts: (state = null, action) => {
    switch (action.type) {
      case FETCH_ACCTS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  offers: (state = null, action) => {
    switch (action.type) {
      case FETCH_OFFERS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  emailSavedResult: (state = null, action) => {
    switch (action.type) {
      case EMAIL_SAVE_ERROR:
      case EMAIL_SAVE_SUCCESS:
      case RESET_PASSWORD_ERROR:
      case RESET_PASSWORD_SUCCESS:
        return action.payload;
      case EMAIL_SAVE_START:
      case RESET_EMAIL_FORM:
      case RESET_PASSWORD_START:
      case CANCEL_RESET_PASSWORD_FORM:
          return null;
      default:
        return state;
    }
  },
  accountSavedResult: (state = null, action) => {
    switch (action.type) {
      case ACCOUNT_SAVE_ERROR:
      case ACCOUNT_SAVE_SUCCESS:
        return action.payload;
      case ACCOUNT_SAVE_START:
        return null;
      default:
        return state;
    }
  },
  updatedAccountNumbers: (state = null, action) => {
    switch (action.type) {
      case EMAIL_SAVE_SUCCESS:
        return action.payload;
      case EMAIL_SAVE_ERROR:
      case RESET_EMAIL_FORM:
        return null;
      case EMAIL_SAVE_START:
        return state;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/summary/reducer.ts